import React from "react";

import withRefluxStore from "../../../../../Stores/withRefluxStore.jsx";
import TemplatePostStore from "../../TemplatePost/TemplatePostStore.js";

import NormalVersion from "./PostEditor__Instagram__Normal.jsx";

import {
  IMAGE_TEMPLATES_INFO,
  VIDEO_TEMPLATES_INFO
} from "@talentbait/remotion-templates-talentbait";

const allTemplatesInfo = { ...IMAGE_TEMPLATES_INFO, ...VIDEO_TEMPLATES_INFO };

function PostEditor({ templateId, currentInputProps, ...rest }) {
  const template = allTemplatesInfo[templateId];

  const isVerticalImageTemplate = template?.orientation === "vertical";
  const isMultiTemplatesOrientation =
    template?.orientation === "multi" && currentInputProps?.orientation === "vertical";

  const isVerticalVideoTemplate = isVerticalImageTemplate || isMultiTemplatesOrientation;

  const shouldRenderVerticalImage = isVerticalImageTemplate || isVerticalVideoTemplate;

  return <NormalVersion {...rest} shouldRenderVerticalImage={shouldRenderVerticalImage} />;
}
export default withRefluxStore(
  PostEditor,
  [TemplatePostStore],
  ["templateId", "currentInputProps"]
);
